/**
 * Genera un slug a partir de un título
 * @param {string} title - El título del artículo
 * @returns {string} - El slug generado
 */
export const slugify = (title) => {
  return title
    .toLowerCase()
    .normalize('NFD') // Decompone caracteres acentuados
    .replace(/[\u0300-\u036f]/g, '') // Elimina diacríticos
    .replace(/[^a-z0-9]+/g, '-') // Reemplaza caracteres no alfanuméricos con guiones
    .replace(/^-+|-+$/g, ''); // Elimina guiones al principio y final
};

export default slugify;
